import {Button} from '@wandb/components';
import React, {FC} from 'react';
// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from 'react-toastify';

import {isParquetExportAllowed} from '../components/RunTriggerParquetExport';
import {useTriggerEventsExportMutation} from '../generated/graphql';
import {useAdminModeActive} from '../util/admin';

type RunTriggerParquetExportProps = {
  runID: string;
};

export const RunTriggerEventsExport: FC<RunTriggerParquetExportProps> = ({
  runID,
}: RunTriggerParquetExportProps) => {
  const isAdmin = useAdminModeActive();
  const [triggerEventsExport] = useTriggerEventsExportMutation();

  if (!isParquetExportAllowed(isAdmin)) {
    return null;
  }

  const onClick = async () => {
    try {
      const response = await triggerEventsExport({
        variables: {runId: runID},
      });
      if (response.errors != null) {
        toast('error triggering parquet export');
        return;
      }
      const taskID = response.data?.triggerEventsExport?.task?.id;
      if (taskID != null) {
        toast(`succesfully triggered parquet export ${taskID}`);
      }
    } catch (err) {
      toast(`error triggering parquet export ${err}`);
    }
  };

  return (
    <Button size="sm" onPress={onClick}>
      Trigger
    </Button>
  );
};
